import { ChevronRight, CheckSquare } from "lucide-react";
import { RelatedAuditsSection } from "./RelatedAuditsSection";
import type { Id } from "@/packages/types";
import { useTranslation } from "@/packages/utils";

interface DocumentDetailLinkedItemsProps {
  documentId: Id<"documents">;
  linkedChecklistCount: number;
  onSwitchToChecklistTab: () => void;
}

export function DocumentDetailLinkedItems({
  documentId,
  linkedChecklistCount,
  onSwitchToChecklistTab,
}: DocumentDetailLinkedItemsProps) {
  const { t } = useTranslation("common");
  return (
    <>
      <RelatedAuditsSection documentId={documentId} />

      {/* Linked checklist items preview */}
      {linkedChecklistCount > 0 && (
        <div>
          <p className="text-[11px] uppercase text-muted font-medium tracking-wider mb-2.5">
            {t("documents.checklistItemsTitle")}
          </p>
          <button
            type="button"
            className="w-full flex items-center gap-3 rounded-xl bg-card/40 border border-border/50 px-4 py-3 hover:bg-card-hover transition-colors group cursor-pointer"
            onClick={onSwitchToChecklistTab}
          >
            <div className="h-8 w-8 rounded-lg bg-emerald-500/10 flex items-center justify-center shrink-0">
              <CheckSquare size={16} className="text-emerald-400" />
            </div>
            <div className="flex-1 text-left min-w-0">
              <p className="text-[13px] text-primary font-medium">
                {t("documents.linkedChecklistItems", {
                  count: linkedChecklistCount,
                  plural: linkedChecklistCount !== 1 ? "s" : "",
                })}
              </p>
              <p className="text-[11px] text-muted">
                {t("documents.viewLinkedRequirements")}
              </p>
            </div>
            <ChevronRight
              size={14}
              className="text-muted group-hover:text-secondary transition-colors shrink-0"
            />
          </button>
        </div>
      )}
    </>
  );
}
